import React, { useEffect, useState } from "react";

export default function EventCalendarSection() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [openMonths, setOpenMonths] = useState({}); // {Sep: true, ...}

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetch("/api/home/event-calendar")
      .then(res => {
        if (!res.ok) throw new Error("Failed to load event calendar");
        return res.json();
      })
      .then(data => {
        setEvents(data);
        // By default, open all months. For collapsed, use {}.
        const months = {};
        data.forEach(ev => months[ev.month] = true);
        setOpenMonths(months);
        setLoading(false);
      })
      .catch(e => {
        setError(e.message || "Unknown error");
        setLoading(false);
      });
  }, []);

  // Group events by month
  const eventsByMonth = {};
  events.forEach(ev => {
    if (!eventsByMonth[ev.month]) eventsByMonth[ev.month] = [];
    eventsByMonth[ev.month].push(ev);
  });

  const monthOrder = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB'); // DD/MM/YYYY
  }


  // Toggle handler
  const toggleMonth = month => {
    setOpenMonths(prev => ({
      ...prev,
      [month]: !prev[month]
    }));
  };

  return (
    <>
      {/* Mobile-friendly table: horizontal scroll and slight font/padding tweak on mobile only */}
      <style>{`
        @media (max-width: 600px) {
          #event-calendar .table-responsive {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
          }
          #event-calendar table {
            min-width: 700px;
            font-size: 13px;
          }
          #event-calendar th, #event-calendar td {
            white-space: nowrap;
            padding: 0.4rem;
          }
          #event-calendar h2 {
            font-size: 22px;
          }
        }
      `}</style>

      <section id="event-calendar" style={{ marginTop: 100, minHeight: 500 }}>
        <div className="container">
          <div className="center wow fadeInDown">
  <h2>VBKP Event Calendar</h2>
                  {/* SGFI Calendar Button */}
                  <a
                    href="https://www.sgfi.org.in/Home/Calender?Cal_Id=5"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      margin: "12px 0 24px",
                      padding: "8px 18px",
                      background: "#337ab7",
                      color: "#fff",
                      borderRadius: 4,
                      fontWeight: "bold",
                      textDecoration: "none",
                      boxShadow: "0 2px 8px rgba(51,122,183,0.1)",
                      transition: "background 0.2s",
                      backgroundColor: "#222",
                    }}
                    onMouseOver={e => e.currentTarget.style.background = "#23527c"}
                    onMouseOut={e => e.currentTarget.style.background = "#337ab7"}
                  >
                    To View SGFI Calendar Click Here
                  </a>
  {error && <p className="lead" style={{ color: "red" }}>{error}</p>}
</div>
          {loading ? (
            <div className="row"><div className="col-md-12 text-center"><p>Loading event calendar...</p></div></div>
          ) : (
            <div className="row">
              <div className="features col-md-12">
                {Object.keys(eventsByMonth).length === 0 ? (
                  <div>No events found.</div>
                ) : (
                  monthOrder.filter(m => eventsByMonth[m]).map(month => (
                    <div key={month} style={{ marginBottom: 40 }}>
                      <h3
                        style={{
                          background: "#f6f6f6",
                          padding: "10px 20px",
                          borderRadius: 4,
                          borderLeft: "5px solid #337ab7",
                          marginBottom: 0,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center"
                        }}
                        onClick={() => toggleMonth(month)}
                      >
                        <span style={{
                          fontSize: 18,
                          marginRight: 12,
                          transition: "transform 0.2s",
                          display: "inline-block",
                          transform: openMonths[month] ? "rotate(90deg)" : "rotate(0)"
                        }}>
                          ▶
                        </span>
                        {month}
                      </h3>
                      {openMonths[month] && (
                        <div className="table-responsive chart-no-select" style={{ borderTop: "1px solid #ddd" }}>
                          <table className="table table-bordered" style={{ background: "#fff" }}>
                            <thead>
                              <tr>
                                <th>Discipline Age/Group</th>
                                <th>Venue</th>
                                <th>Event Date</th>
                                <th>Status</th>
                                <th>Official Entry Date</th>
                                <th>View</th>
                              </tr>
                            </thead>
                            <tbody>
                              {eventsByMonth[month].map((event, idx) => (
                                <tr key={idx}>
                                  <td>{event.venue}</td>
                                  <td>{event.discipline}</td>
                                  <td>
                                    {formatDate(event.eventStartDate)} to {formatDate(event.eventEndDate)}
                                  </td>
                                  <td>{event.dtStatus}</td>
                                  <td>
                                    {formatDate(event.entryOpenDate)} to {formatDate(event.entryCloseDate)}
                                  </td>
                                  <td>
                                    {event.pathUrl ? (
                                      <a href={event.pathUrl} target="_blank" rel="noopener noreferrer">
                                        {event.remark || "View"}
                                      </a>
                                    ) : (
                                      event.remark || "-"
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

// Helper: Format DD-MM-YYYY or fallback
function formatDate(str) {
  if (!str) return "";
  const parts = str.split(" ")[0].split("-");
  if (parts.length !== 3) return str;
  return `${parts[0]}-${parts[1]}-${parts[2]}`;
}
